var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8359 3.66667H5.0026C4.56058 3.66667 4.13665 3.84226 3.82409 4.15482C3.51153 4.46738 3.33594 4.89131 3.33594 5.33333V15.3333C3.33594 15.7754 3.51153 16.1993 3.82409 16.5118C4.13665 16.8244 4.56058 17 5.0026 17H10.8359M14.1693 3.66667H15.0026C15.4446 3.66667 15.8686 3.84226 16.1811 4.15482C16.4937 4.46738 16.6693 4.89131 16.6693 5.33333V6.16667M16.6693 14.5V15.3333C16.6693 15.7754 16.4937 16.1993 16.1811 16.5118C15.8686 16.8244 15.4446 17 15.0026 17H14.1693M16.6693 9.5V11.1667M10.0026 2V18.6667",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompare);
export default __webpack_public_path__ + "static/media/compare.3d1dbd544a1e76223485432864595f8a.svg";
export { ForwardRef as ReactComponent };